var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":"","scroll-region":"","transition":"scroll-x-transition"}},[_c('v-row',{attrs:{"align":"center"}},[_c('v-col',{attrs:{"cols":"6","justify-center":""}},[_vm._v("\n      Erfolgreich gespeichert. Sie können den Browser nun schließen.\n    ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }